import { type ChangeEvent, useEffect } from 'react';

import { faArrowUp, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/ui/button';
import { useSelector } from 'react-redux';
import { toast } from 'sonner';

import { PPD_VALID_FILE_TYPES_ARRAY } from '../../constants';
// eslint-disable-next-line import/order -- There should be no empty line within import group
import { useStartFileUpload } from '../../react-query/useStartFileUpload';
// TODO: Clean this up once we refactor the routes file to not contain business logic
import { isMultiPracticeUser } from '../login/login-utils';

export const UploadRadiographs = () => {
  // selectors
  const user = useSelector((state: any) => state?.login?.user);

  // hooks
  const { mutate, isLoading, isSuccess, isError } = useStartFileUpload();

  // variables
  const shouldPreventUpload = isMultiPracticeUser(user);
  const validFileTypesWithLeadingDecimal = PPD_VALID_FILE_TYPES_ARRAY.map(
    (fileType) => `.${fileType}`,
  );

  // handlers
  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      return;
    }
    const filesArray = Array.from(event.target.files);
    mutate(filesArray);
  };

  // Show toast notifications
  useEffect(() => {
    if (isSuccess) {
      toast.success('Upload Complete');
    }
    if (isError) {
      toast.error('Something went wrong. Please try again.');
    }
  }, [isSuccess, isError]);

  return (
    <>
      <Button
        variant="outline"
        disabled={isLoading || shouldPreventUpload}
        onClick={() => document.getElementById('file-input')?.click()}
        
      >
        <FontAwesomeIcon
          icon={isLoading ? faSpinner : faArrowUp}
          className={`vai-h-4 vai-w-4 vai-mr-2 ${
            isLoading ? 'vai-animate-spin' : ''
          }`}
        />
        {isLoading ? 'Uploading and analyzing Images...' : 'Upload'}
      </Button>
      <input
        id="file-input"
        data-testid="file-input"
        hidden
        multiple
        type="file"
        accept={validFileTypesWithLeadingDecimal.join(',')}
        onChange={(e) => handleFileChange(e)}
        disabled={isLoading || shouldPreventUpload}
      />
    </>
  );
};
